var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import _get from 'lodash/get';
import { MdSelect as MaterialAutocomplete, MdField as MaterialField } from '@bytebrand/fe-ui-core-autobahn/compat';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import styles from './DealerAddressModal.styl';
import FormFieldInput from '../../../ui/FormFieldInput/FormFieldInput';
import FormFieldDropDown from '../../../ui/FormFieldDropDown/FormFieldDropDown';
import form, { fieldsNames } from '../../../pages/DealerPages/forms/DealerProfileForm';
import { inject, observer } from 'mobx-react';
import { PHONE_PREFIXES } from 'framework/constants/forms';
import { get, includes, isNil } from 'lodash';
let phoneExist = false;
let DealerAddressModal = class DealerAddressModal extends React.Component {
    constructor() {
        super(...arguments);
        /**
       * Initializes the form by disabling and resetting 'fieldName' field,
       * and updating the phone numbers with countryCode, areaCode, and phoneNumber.
       */
        Object.defineProperty(this, "initForms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { fieldName, profileStore } = this.props;
                // Get the 'fieldName' field from the Form instance and enable/disable it.
                const field = form.$(fieldName);
                this.deepDisable(field, false);
                // Check if 'fieldName' has phone numbers stored in profileStore
                // for countryCode, areaCode, and phoneNumber and set them with values retrieved from profileStore. 
                // Else, disable "fieldName" field and its each child fields.
                if (fieldName === fieldsNames.contactAddress) {
                    phoneExist =
                        get(profileStore, ['dealerProfileEdit', fieldName]) &&
                            get(profileStore, ['dealerProfileEdit', fieldName])?.phoneMain != null
                            ? true
                            : false;
                    if (phoneExist) {
                        field.reset(false);
                        const mainPhoneNumber = field.$(`${fieldsNames.phoneMain}.phoneNumber`).value
                            ? `${field.$(`${fieldsNames.phoneMain}.countryCode`).value.value
                                ? field.$(`${fieldsNames.phoneMain}.countryCode`).value.value
                                : field.$(`${fieldsNames.phoneMain}.countryCode`).value}${_get(field.$(`${fieldsNames.phoneMain}.areaCode`), 'value', '')}${_get(field.$(`${fieldsNames.phoneMain}.phoneNumber`), 'value', '')}`
                            : '';
                        const mobilePhoneNumber = field.$(`${fieldsNames.phoneMobile}.phoneNumber`).value
                            ? `${field.$(`${fieldsNames.phoneMobile}.countryCode`).value.value
                                ? field.$(`${fieldsNames.phoneMobile}.countryCode`).value.value
                                : field.$(`${fieldsNames.phoneMobile}.countryCode`).value}${_get(field.$(`${fieldsNames.phoneMobile}.areaCode`), 'value', '')}${_get(field.$(`${fieldsNames.phoneMobile}.phoneNumber`), 'value', '')}`
                            : '';
                        field.$(`${fieldsNames.phoneMain}.countryCode`).set('');
                        field.$(`${fieldsNames.phoneMain}.areaCode`).set('');
                        field.$(`${fieldsNames.phoneMain}.phoneNumber`).set(mainPhoneNumber);
                        field.$(`${fieldsNames.phoneMobile}.countryCode`).set('');
                        field.$(`${fieldsNames.phoneMobile}.areaCode`).set('');
                        field.$(`${fieldsNames.phoneMobile}.phoneNumber`).set(mobilePhoneNumber);
                        field.$(`${fieldsNames.phoneMain}.countryCode`).set('rules', '');
                        field.$(`${fieldsNames.phoneMobile}.countryCode`).set('rules', '');
                        field.$(`${fieldsNames.phoneMobile}.areaCode`).set('rules', '');
                    }
                    else {
                        field.reset();
                        field.set('disabled', true);
                        field.each((field) => field.set('disabled', true));
                    }
                    // Set validation rules to phone fields based on their value existence
                    field.$(`${fieldsNames.phoneMain}.areaCode`).set('rules', phoneExist
                        ? ['']
                        : ['phone_areaCode', 'required']);
                    field.$(`${fieldsNames.phoneMobile}.phoneNumber`).set('rules', phoneExist
                        ? ['phone']
                        : ['phone_phoneNumber']);
                    field.$(`${fieldsNames.phoneMain}.phoneNumber`).set('rules', phoneExist
                        ? ['phone', 'required']
                        : ['phone_phoneNumber', 'required']);
                }
            }
        });
        Object.defineProperty(this, "createNestedRenderField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Field => (t, field, nestedFieldName, key) => {
                const nestedField = field.$(nestedFieldName);
                return (React.createElement(MaterialField, { onChange: value => nestedField.onChange(value, nestedField.name), label: t(`${nestedField.label}`), value: nestedField.value, type: nestedField.type, size: 'custom', className: styles[nestedFieldName], required: includes(field.$(nestedFieldName).rules, 'required') ? true : false, error: nestedField.hasError && nestedField.error }));
            }
        });
        Object.defineProperty(this, "createNestedRenderDropDown", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Field => (t, field, nestedFieldName, key) => {
                const nestedField = field.$(nestedFieldName);
                const changeValue = (field, elValue) => {
                    if (isNil(elValue) || typeof (elValue) === 'number') {
                        const changeValue = field.extra.find(({ value }) => value === elValue);
                        return changeValue;
                    }
                };
                return (React.createElement(MaterialAutocomplete, { onChange: value => nestedField.onChange(changeValue(nestedField, value)), value: !nestedField.value ? null : t(`common:${nestedField.value.label}`), label: t(nestedField.label), error: nestedField.hasError && nestedField.error, required: nestedField.value === '' ? true : false, items: nestedField.extra.map((option) => ({
                        value: option.value,
                        label: t(`common:${option.label}`)
                    })), size: 'custom', className: styles[nestedFieldName], disableClearable: true }));
            }
        });
        Object.defineProperty(this, "renderStreet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (t, field, nestedFieldName, key) => {
                const streetField = field.$(fieldsNames.street);
                const numberField = field.$(fieldsNames.number);
                return (React.createElement(React.Fragment, null,
                    React.createElement(MaterialField, { onChange: value => streetField.onChange(value, streetField.name), label: t(`${streetField.label}`), value: streetField.value, type: streetField.type, size: 'custom', className: styles[nestedFieldName], required: includes(field.$(nestedFieldName).rules, 'required') ? true : false, error: streetField.hasError && streetField.error }),
                    React.createElement(MaterialField, { onChange: value => numberField.onChange(value, numberField.name), label: t(`${numberField.label}`), value: numberField.value, type: numberField.type, size: 'custom', className: styles.number, required: includes(field.$(nestedFieldName).rules, 'required') ? true : false, error: numberField.hasError && numberField.error })));
            }
        });
        Object.defineProperty(this, "renderPhone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isOptional = false) => (t, field, nestedFieldName) => {
                const phoneField = field.$(fieldsNames[nestedFieldName]);
                const isMainAddress = field.name === 'mainAddress';
                const isPhoneMain = nestedFieldName === 'phoneMain';
                // Get the phoneNumber from phoneMain or phoneMobile fields depending on isPhoneMain 
                const countryCode = isPhoneMain
                    ? field.$(`${fieldsNames.phoneMain}.countryCode`)
                    : field.$(`${fieldsNames.phoneMobile}.countryCode`);
                // Get the areaCode from phoneMain or phoneMobile fields depending on isPhoneMain 
                const areaCode = isPhoneMain
                    ? field.$(`${fieldsNames.phoneMain}.areaCode`)
                    : field.$(`${fieldsNames.phoneMobile}.areaCode`);
                // Get the phoneNumber from phoneMain or phoneMobile fields depending on isPhoneMain 
                const phoneNumber = isPhoneMain
                    ? field.$(`${fieldsNames.phoneMain}.phoneNumber`)
                    : field.$(`${fieldsNames.phoneMobile}.phoneNumber`);
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles[`label_${nestedFieldName}`] }, t(`label.${nestedFieldName}`)),
                    phoneExist
                        ? React.createElement(MaterialField, { onChange: (value) => phoneNumber.onChange(value, phoneNumber.name), label: t(`${phoneNumber.placeholder}`), value: phoneNumber.value, type: phoneNumber.type, size: 'custom', className: styles[`${nestedFieldName}_fullPhone`], required: includes(phoneNumber.rules, 'required'), error: phoneNumber.hasError && phoneNumber.error })
                        : (React.createElement(React.Fragment, null,
                            React.createElement(MaterialAutocomplete, { onChange: (value) => countryCode.onChange(value), label: t(countryCode.placeholder), value: countryCode.value, error: countryCode.hasError && countryCode.error, required: countryCode.value === '' ? true : false, items: PHONE_PREFIXES, size: 'custom', className: styles[`${nestedFieldName}_countryCode`], disableClearable: true, listWithImage: 'true' }),
                            React.createElement(MaterialField, { onChange: (value) => areaCode.onChange(value, areaCode.name), label: t(`${areaCode.placeholder}`), value: areaCode.value, type: areaCode.type, size: 'custom', className: styles[`${nestedFieldName}_areaCode`], required: includes(areaCode.rules, 'required'), error: areaCode.hasError && areaCode.error }),
                            React.createElement(MaterialField, { onChange: (value) => phoneNumber.onChange(value, phoneNumber.name), label: t(`${phoneNumber.placeholder}`), value: phoneNumber.value, type: phoneNumber.type, size: 'custom', className: styles[`${nestedFieldName}_phoneNumber`], required: phoneNumber.value === '' ? true : false, error: phoneNumber.hasError && phoneNumber.error })))));
            }
        });
        Object.defineProperty(this, "replaceField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (renderField, replace) => (t, field, nestedFieldName, key) => renderField(t, replace(field), nestedFieldName, key)
        });
        Object.defineProperty(this, "renderNestedFieldsFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (t, fieldName) => (nestedFieldName, key) => {
                const { mainAddress, title, street, city, zip, firstName, lastName, gender, company, phoneMain, phoneMobile, fax, ustIdNr, country, website, email, commercialRegister, commercialRegisterNumber, authorizedRepresentative } = fieldsNames;
                return ({
                    [title]: this.createNestedRenderDropDown(FormFieldDropDown),
                    [street]: this.renderStreet,
                    [city]: this.createNestedRenderField(FormFieldInput),
                    [zip]: this.createNestedRenderField(FormFieldInput),
                    [firstName]: this.createNestedRenderField(FormFieldInput),
                    [lastName]: this.createNestedRenderField(FormFieldInput),
                    [gender]: this.createNestedRenderDropDown(FormFieldDropDown),
                    [company]: this.createNestedRenderField(FormFieldInput),
                    [phoneMain]: this.renderPhone(),
                    [phoneMobile]: this.renderPhone(true),
                    [fax]: this.renderPhone(true),
                    [ustIdNr]: this.createNestedRenderField(FormFieldInput),
                    [country]: this.createNestedRenderDropDown(FormFieldDropDown),
                    [website]: this.replaceField(this.createNestedRenderField(FormFieldInput), (field => field.name === mainAddress ? form : field)),
                    [email]: this.replaceField(this.createNestedRenderField(FormFieldInput), (field => field.name === mainAddress ? form : field)),
                    [commercialRegister]: this.createNestedRenderField(FormFieldInput),
                    [commercialRegisterNumber]: this.createNestedRenderField(FormFieldInput),
                    [authorizedRepresentative]: this.createNestedRenderField(FormFieldInput)
                })[nestedFieldName](t, form.$(fieldName), nestedFieldName, key);
            }
        });
        Object.defineProperty(this, "renderFieldFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (t, fieldName) => {
                const renderNestedField = this.renderNestedFieldsFactory(t, fieldName);
                const { mainAddress, contactAddress, billingAddress, businessAddress, gender, title, firstName, lastName, company, website, email, phoneMain, phoneMobile, fax, street, zip, city, country, ustIdNr, commercialRegister, commercialRegisterNumber, authorizedRepresentative } = fieldsNames;
                return ({
                    [mainAddress]: [
                        [gender, title, firstName, lastName, company, website, email, phoneMain, phoneMobile, fax],
                        [street, zip, city, country, ustIdNr, commercialRegister, commercialRegisterNumber, authorizedRepresentative]
                    ],
                    [contactAddress]: [
                        [gender, firstName, lastName],
                        [phoneMain, phoneMobile, email]
                    ],
                    [billingAddress]: [
                        [company, gender, firstName, lastName],
                        [street, zip, city, country, email]
                    ],
                    [businessAddress]: [
                        [company, gender, firstName, lastName],
                        [street, zip, city, country, email]
                    ]
                })[fieldName].map(nestedFieldsNames => nestedFieldsNames.map(renderNestedField));
            }
        });
        Object.defineProperty(this, "disable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (field, disabled) => {
                if (disabled) {
                    field.clear(false);
                    field.resetValidation(false);
                }
                field.set('disabled', disabled);
            }
        });
        Object.defineProperty(this, "deepDisable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (field, disabled) => {
                this.disable(field, disabled);
                field.each((field) => this.disable(field, disabled));
            }
        });
        Object.defineProperty(this, "onRemove", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { fieldName, hideModal } = this.props;
                const field = form.$(fieldName);
                this.deepDisable(field, true);
                field.submit().then(() => {
                    hideModal('DEALER_ADDRESS_MODAL');
                    this.onDiscard();
                });
            }
        });
        Object.defineProperty(this, "onDiscard", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { fieldName, hideModal } = this.props;
                const fields = [form.$(fieldName)];
                if (fieldName === fieldsNames.mainAddress) {
                    fields.push(form.$(fieldsNames.email), form.$(fieldsNames.website));
                }
                fields.forEach((field) => {
                    field.resetValidation();
                });
                hideModal('DEALER_ADDRESS_MODAL');
            }
        });
        Object.defineProperty(this, "onSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { fieldName, hideModal } = this.props;
                const fields = [form.$(fieldName)];
                if (fieldName === fieldsNames.mainAddress) {
                    fields.push(form.$(fieldsNames.email), form.$(fieldsNames.website));
                }
                fields.map(field => field.each((field) => field.set('disabled', false)));
                Promise.all(fields.map(field => field.submit())).then((fields) => {
                    if (fields.every(field => field.isValid)) {
                        if (fieldName === fieldsNames.mainAddress) {
                            const accountHolderField = form.$(fieldsNames.paymentAccount).$(fieldsNames.accountHolder);
                            if (!accountHolderField.get('default')) {
                                accountHolderField.set(fields[0].$(fieldsNames.company).values());
                                accountHolderField.resetValidation();
                            }
                        }
                        hideModal('DEALER_ADDRESS_MODAL');
                    }
                });
            }
        });
    }
    UNSAFE_componentWillMount() {
        this.initForms();
    }
    componentWillUnmount() {
        const { fieldName } = this.props;
        const field = form.$(fieldName);
        if (fieldName !== fieldsNames.mainAddress) {
            if (field.isEmpty) {
                field.resetValidation(true);
                field.set('disabled', true);
                field.each((field) => field.set('disabled', true));
            }
        }
    }
    render() {
        const { t, fieldName } = this.props;
        const field = form.$(fieldName);
        return (React.createElement("div", { className: styles.wrapper },
            React.createElement("span", { className: styles.textSubheader }, t(`subheader.${fieldName}`)),
            React.createElement("form", { className: styles.gridWrapper, autoComplete: 'off' }, this.renderFieldFactory(t, fieldName).map((nestedFields, key) => (React.createElement(React.Fragment, { key: key }, nestedFields)))),
            React.createElement("div", null,
                React.createElement("div", { className: styles.blockModalButton },
                    fieldName !== fieldsNames.mainAddress && !field.isEmpty && (React.createElement(Button, { variant: 'text', className: styles.remove, onClick: this.onRemove }, t(`ui.button.remove.${fieldName}`))),
                    React.createElement(Button, { variant: 'outlined', className: styles.button, onClick: this.onDiscard }, t('ui.button.discard')),
                    React.createElement(Button, { variant: 'filled', className: styles.button, onClick: this.onSave }, t('ui.button.save.data'))))));
    }
};
DealerAddressModal = __decorate([
    inject('authStore', 'appStore', 'profileStore', 'notificationStore'),
    observer
], DealerAddressModal);
export default DealerAddressModal;
